import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function Fee() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Fee Structure"
          title2=""
          parentTitle="Academics"
          path="Fee Structure"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="contact-form-card manage">
            <h2 className="about-title">Fee Structure</h2>

            <div className="about-content-card">
              {/* BULLET SECTION */}
              <div className="affiliation-list mt-3">
                <div className="affiliation-item">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    The school does not receive any financial assistance from
                    the government and hence has to meet all the running
                    expenses from the fees. The management therefore reserves
                    the right to make alterations in the fees from time to time.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    School fees are fixed by the governing body. The school fees
                    cover 12 months and must be paid either in four instalments
                    in April, July, October & January or in every month. Fees
                    will be taken from 1th to 15th of every month, in the
                    bank(Axis bank, maheshtala) except on second Saturday,
                    holidays and Sundays. Defaulters will have to pay a late fee
                    of RS 100/- per month. Those who wish may pay fees of the
                    whole terms in advance.
                  </span>
                </div>
                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    No reduction is made for holidays and broken periods.
                    Admission and other fees are not refunded. Students are
                    liable to be charged full fees as long as their names are
                    officially on roll.
                  </span>
                </div>
                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Students are expected to clear all their dues before each
                    terminal examination.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Receipts are issued for every payment made and parents are
                    requested to make sure that they receive the receipts.
                    Duplicate receipts will not be issued. However a certificate
                    of payment will be issued on payment of RS 50/- each time.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    In case of any misplacement of the fee book RS 100/- will be
                    fined.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Fee;
